import Icon from '../../components/Icon';
import { Checkbox } from '@mui/material';
import { AlertItemCheckBoxType } from '../../types';
import { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";

export interface AlertItemCheckBoxProps {
    item: AlertItemCheckBoxType
    handleCheckboxChange: (layerId: string, isChecked: boolean) => void
    onLabelClick?: (layerId: string) => void
    availableTypes?: string[]
    alertCount?: number // Nouveau prop pour le nombre d'alertes
}

export default function AlertItemCheckbox ({
    item, 
    handleCheckboxChange, 
    onLabelClick, 
    availableTypes = [],
    alertCount = 0
}: AlertItemCheckBoxProps) {
  const [isChecked, setIsChecked] = useState<boolean>(item.isShow)
  const { t } = useTranslation();

  // Vérifier si ce type d'alerte est disponible dans les données (pour feedback visuel uniquement)
  const isTypeAvailable = availableTypes.includes(item.type);

  useEffect(() => {
    setIsChecked(item.isShow)
  }, [item])

  const onCheckboxChange = () => {
    // Permettre l'interaction libre - plus de restriction basée sur availableTypes
    const statusCheck = !isChecked;
    setIsChecked(statusCheck);
    handleCheckboxChange(item.id, statusCheck);
  }

  const handleLabelClick = (event: React.MouseEvent) => {
    // Permettre l'interaction libre - plus de restriction basée sur availableTypes
    // Empêcher la propagation pour éviter que la checkbox soit déclenchée
    event.preventDefault();
    event.stopPropagation();
    
    if (onLabelClick) {
      onLabelClick(item.id);
    }
  }

  const handleCheckboxClick = (event: React.MouseEvent) => {
    // Empêcher la propagation pour éviter que le label soit déclenché
    event.stopPropagation();
  }

  return (
    <label 
        className='alertItem' 
        onClick={handleLabelClick} 
        style={{ opacity: isTypeAvailable ? 1 : 0.5 }}
    >
        <Icon containerStyle={{flex: 1}} type={`${item.iconType}_alert`} iconStyle={{height:'30px', width: '30px'}}/>
        <span style={{flex: 4, fontSize: 13}}>
            {t(`weatherLabel.${item.id}`)}
            <span style={{ marginLeft: 8, color: isTypeAvailable ? 'inherit' : '#9e9e9e' }}>
                ({alertCount ?? 0})
            </span>
        </span>
        <Checkbox 
          style={{flex: 1}} 
          name={item.iconType} 
          size='small' 
          checked={isChecked}
          disabled={false} // Plus de désactivation basée sur availableTypes
          onChange={onCheckboxChange}
          onClick={handleCheckboxClick}
        />
    </label>
  );
}